let exhibitGroups = {
  'perennial': [
                '45fee1ce-bd15-8f08-e20a-23f18b9236b6',
                '85d8caaa-895e-9d05-6133-d2b58899fec7',
                '9fe812e9-d193-e1b4-159e-1e29945d6a96',
                '773e74d3-aa12-23a6-f02c-3268fd6fb5ec',
                '64f54ec7-dad9-9e39-3587-0b9fd7702ceb',
                '0fba8340-e96e-8203-f4a9-6e0e42f6a666'
              ]
}
export default exhibitGroups
